export default "__VITE_ASSET__d5855ddb__"